import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const ThemeCtx = createContext(null);

export function ThemeProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem("rentalpro_dark") === "1");

  const load = async () => {
    try {
      const r = await api.get("/settings");
      setSettings(r.data);
      applyTheme(r.data);
    } catch (e) { /* ignore */ }
  };

  const applyTheme = (s) => {
    if (!s) return;
    document.documentElement.style.setProperty("--brand-primary", s.primary_color);
    document.documentElement.style.setProperty("--brand-secondary", s.secondary_color);
    document.title = s.business_name || "RentalPro";
    if (s.logo_base64) {
      let link = document.querySelector("link[rel='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = s.logo_base64;
    }
  };

  const applyDark = (on) => {
    if (on) document.documentElement.setAttribute("data-theme", "dark");
    else document.documentElement.removeAttribute("data-theme");
  };

  const toggleDark = () => {
    setDarkMode(prev => {
      const nv = !prev;
      localStorage.setItem("rentalpro_dark", nv ? "1" : "0");
      applyDark(nv);
      return nv;
    });
  };

  useEffect(() => { applyDark(darkMode); }, []); // eslint-disable-line
  useEffect(() => { load(); }, []);

  return <ThemeCtx.Provider value={{ settings, reload: load, applyTheme, darkMode, toggleDark }}>{children}</ThemeCtx.Provider>;
}

export const useTheme = () => useContext(ThemeCtx);
